module.exports = __webpack_public_path__ + "static/img/about.e6947d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about.png
// module id = FhzR
// module chunks = 1